/** Hardcoded account IDs of accounts used by CIO for demonstration purposes.
 * The initial need for this is that these accounts state is set to "free", which
 * makes them be detected as trial accounts in some places (a more robust
 * trial detection has faced some permisssion issues in the past).
 *
 * This is intended to be a temporary solution until we either have a more
 * robust trial detection or we don't need to treat these accounts differently.
 */

const DEMO_ACCOUNT_IDS = [31505, 61962, 1];

export const isDemoAccount = (accountId: number) => {
  return DEMO_ACCOUNT_IDS.includes(accountId);
};
